import { render, staticRenderFns } from "./UpgradeUserData.vue?vue&type=template&id=5b5fdd9e&scoped=true&"
import script from "./UpgradeUserData.vue?vue&type=script&lang=js&"
export * from "./UpgradeUserData.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeUserData.vue?vue&type=style&index=0&id=5b5fdd9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5fdd9e",
  null
  
)

export default component.exports